module.exports = __webpack_public_path__ + "img/bj001-001.c5fe2bb0.jpg";